/**
 * The empty-room hand-off (`designs/01-now/2026-09-06-empty-room-handoff-design.md`): the one unanswered
 * post by somebody else that the viewer is offered after publishing.
 *
 * Hand-written per AGENTS.md rule 6, because `GET /ajax/discussions/unanswered/next` is not in the
 * generated client (0 `/ajax/discussions` operations in `src/generated-client/api.ts` at HEAD); the
 * integrator's `make sync-client-local` supersedes it. Mirrors `HandoffService.HandoffCandidate` in
 * `MainService`, served by `AjaxHandoffRestController` (200 with this body, or 204 with none).
 */
export type HandoffCandidate = {
    discussionPublicId: string;
    title: string;
    authorUsername: string;
    /** Root-relative permalink of the offered post, e.g. `/discussion/{publicId}`. */
    url: string;
    /**
     * FI-200 (round 31 `1c`): the post's excerpt, for the copy A/B's variant B. Null for a spoiler post or
     * a post without one. Optional so a card served by a backend that predates the field renders today's
     * control copy (the deploy halves are order-independent).
     */
    excerpt?: string | null;
    /** The viewer's arm of `handoff_offer_copy`: `control` (or absent) is today's card. */
    variant?: string | null;
};

/** Variant B of the hand-off copy A/B; mirrors `HandoffService.VARIANT_TITLE_EXCERPT`. */
export const HANDOFF_VARIANT_TITLE_EXCERPT = "title_excerpt";
